import { TableFooter, TableRow } from '@mui/material';

import {
  BankCharge,
  BankDossier,
} from '../../../../api/workOrders/bankDossier';
import { Constants } from '../../../../constants/bankDossier';
import {
  dossierDateTime,
  moneyOrEmpty,
  textOrEmpty,
} from '../../../../helpers/bankDossier';
import { DossierColumn, DossierTable } from '../../DossierTable';
import {
  BodyCell,
  FooterCell,
  MoneyCell,
  MutedCell,
} from '../../DossierTable/styles';

interface SectionProps {
  dossier: BankDossier;
}

const { columns } = Constants.charges;

const chargeColumns: DossierColumn[] = [
  { key: 'fee_type', label: columns.feeType },
  { key: 'charge_type', label: columns.chargeType },
  { key: 'bank', label: columns.bankCharged, align: 'right' },
  { key: 'appraiser', label: columns.appraiserFee, align: 'right' },
  { key: 'platform', label: columns.platformFee, align: 'right' },
  { key: 'created_at', label: columns.createdAt },
  { key: 'notes', label: columns.notes },
];

export function ChargesSection({ dossier }: SectionProps): JSX.Element {
  const { charges } = dossier;

  const renderRow = (row: BankCharge): JSX.Element => (
    <>
      <BodyCell>{row.fee_type}</BodyCell>
      <MutedCell>{textOrEmpty(row.charge_type)}</MutedCell>
      <MoneyCell align="right">
        {moneyOrEmpty(row.bank_charged_value)}
      </MoneyCell>
      <MoneyCell align="right">{moneyOrEmpty(row.appraiser_fee)}</MoneyCell>
      <MoneyCell align="right">{moneyOrEmpty(row.platform_fee)}</MoneyCell>
      <BodyCell sx={{ whiteSpace: 'nowrap' }}>
        {dossierDateTime(row.created_at)}
      </BodyCell>
      <MutedCell>{textOrEmpty(row.notes)}</MutedCell>
    </>
  );

  const footer = charges.items.length > 0 && (
    <TableFooter>
      <TableRow>
        <FooterCell colSpan={2}>{Constants.charges.totalBank}</FooterCell>
        <FooterCell align="right">
          {moneyOrEmpty(charges.total_bank_charges)}
        </FooterCell>
        <FooterCell colSpan={4} />
      </TableRow>
      <TableRow>
        <FooterCell colSpan={2}>{Constants.charges.totalFees}</FooterCell>
        <FooterCell />
        <FooterCell align="right">
          {moneyOrEmpty(charges.total_fees)}
        </FooterCell>
        <FooterCell colSpan={3} />
      </TableRow>
    </TableFooter>
  );

  return (
    <DossierTable<BankCharge>
      columns={chargeColumns}
      rows={charges.items}
      getRowId={(row) => row.id}
      renderRow={renderRow}
      emptyMessage={Constants.charges.empty}
      footer={footer || undefined}
      ariaLabel={Constants.sections.charges}
    />
  );
}
